import { Button, Modal, message } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import type { PartnerRule } from '@shipium-corp/shipium-ts-types';
import { describeRule, type NamedRef } from '~/services/mastra-service';

interface DescribeRuleButtonProps {
  rule: PartnerRule;
  carrierNames?: NamedRef[];
  tenantNames?: NamedRef[];
}

export function DescribeRuleButton({ rule, carrierNames, tenantNames }: DescribeRuleButtonProps) {
  const mutation = useMutation({ mutationFn: () => describeRule(rule, carrierNames, tenantNames) });

  return (
    <Button
      icon={<FileTextOutlined />}
      loading={mutation.isPending}
      onClick={() => {
        mutation.mutate(undefined, {
          onSuccess: (result) => {
            Modal.info({
              title: 'Rule Description',
              width: 600,
              content: <p>{result.description}</p>,
            });
          },
          onError: (error) => {
            console.error('Describe rule error:', error);
            message.error('Failed to describe rule. Please try again.');
          },
        });
      }}
    >
      Describe
    </Button>
  );
}
